import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListLocais from '../../components/locais/social';


function ListSocialScreen() {
    return (
        <Fragment>
            <Head titulo="Unidades de Atendimento de Assistência Social em Macuco" />
            <Header />
            <Container>
               <ListLocais /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListSocialScreen;